<template>
  <v-app id="app" :dark="false">
    <router-view></router-view>
    <NotificacionComponent />
    <CargandoComponent />
    <LoginFakeComponent :active="openModal" />
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    components: {
      NotificacionComponent: () => import('@/components/utilites/NotificacionComponent.vue'),
      CargandoComponent: () => import('@/components/utilites/CargandoComponent.vue'),
      LoginFakeComponent: () => import('@/components/utilites/LoginFakeComponent.vue')
    },
    data: () => ({
      time: 0,
      timeStopMax: 900000,
      abreVerificacion : false,
      openModal: false,
      isCliente:false
    }),
    provide(){
      return{
        closeModalLoginFake: this.close
      }
    },
    watch:{
      openModal(val){
        // if(!val)
          // this.sensarActividad(true);
      }
    },
    methods: {
      close(){
        this.openModal = false;
      },
      sensarActividad(state) {
        // console.log(this.abreVerificacion + "<<");
        if (state) {
          console.log('watcher on');
          this.evtMouseMove();
          this.evtKeyPress();
          this.evtTouchMove();  
        } else {
          console.log('watcher off');
          this.abreVerificacion = true;
          this.evtMouseMove(false);
          this.evtKeyPress(false);
          this.evtTouchMove(false);  
        }
      },
      evtMouseMove(active=true){
        if(active)
          window.addEventListener('mousemove', () => { if(!this.abreVerificacion) this.counter(); });
        else
          window.removeEventListener('mousemove', () => {  console.log('keypress cerrada'); });
      },
      evtKeyPress(active=true){
        if(active)
          window.addEventListener("keypress", (evt) => { if(!this.abreVerificacion) this.counter(); });
        else
          window.removeEventListener('keypress', () => { console.log('keypress cerrada'); }, false);
      },
      evtTouchMove(active=true){
        if(active)
          window.addEventListener("touchmove",(evt) => { if(!this.abreVerificacion) this.counter(); });
        else
          window.addEventListener("touchmove",(evt) => { console.log('touchmove cerrada') });
      },
      counter() {
        clearTimeout(this.time);
        this.time= setTimeout(()=>{
				  console.log('se cerro la sesion')
				  this.bloquearSesion();
			},this.timeStopMax);
      },
      bloquearSesion() {
        this.sensarActividad(false);
        this.openModal = true;
      }
    },
    beforeMount() {
      // Add a request interceptor
      axios.interceptors.request.use((config) => {
        // Do something before request is sent
        window.mensajesAlerta = this.$root.mensajeAlerta;
        window.loading = this.$root.onCargando;
        window.mensajeAlertaTiempo = this.$root.notificacionMensaje;

        this.$root.loading.mostrar = true;
        return config;
      }, (error) => {
        // Do something with request error
        this.$root.loading.mostrar = false;
        return Promise.reject(error);
      });

      // Add a response interceptor
      axios.interceptors.response.use((response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        this.$root.loading.mostrar = false;
        return response;
      }, (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        this.$root.loading.mostrar = false;
        return Promise.reject(error);
      });
    },
    mounted() {
      this.$root.isTouch = window.Modernizr.touch;
      this.sensarActividad(true);
    }
  }
</script>